import React from 'react';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-xl font-semibold text-white mb-3">{title}</h2>
    <div className="text-gray-400 text-sm leading-relaxed space-y-2">{children}</div>
  </div>
);

const Terms = () => (
  <div className="min-h-screen py-16 px-6">
    <div className="max-w-3xl mx-auto">
      <h1 className="text-4xl font-bold text-white mb-2">Terms of Service</h1>
      <p className="text-gray-500 text-sm mb-10">Last updated: April 14, 2026</p>

      <Section title="1. Acceptance of Terms">
        <p>By creating an account or using globalnow.biz ("Service"), you agree to these Terms of
        Service. If you do not agree, do not use the Service.</p>
      </Section>

      <Section title="2. The Service">
        <p>globalnow.biz provides an AI-powered website builder, content generation tools, and
        AI chat features for small businesses. The Service is provided "as is" and we reserve
        the right to modify, suspend, or discontinue features with reasonable notice.</p>
      </Section>

      <Section title="3. Account Registration">
        <p>You must provide accurate information when creating an account. You are responsible
        for maintaining the security of your password. You must be at least 18 years old to
        use the Service.</p>
      </Section>

      <Section title="4. Lifetime Deal — What It Means">
        <p>A "Lifetime Deal" (LTD) purchase grants you access to the Service for as long as
        globalnow.biz operates. "Lifetime" refers to the lifetime of the product, not your
        personal lifetime. We intend to operate this service long-term and will provide
        reasonable advance notice (minimum 90 days) if the service is ever discontinued.</p>
        <p>LTD access includes all features available at the time of purchase plus future
        features added to the same tier. We reserve the right to introduce new higher tiers
        for advanced features.</p>
      </Section>

      <Section title="5. Acceptable Use">
        <p>You may not use the Service to:</p>
        <p>• Generate illegal, harmful, abusive, or deceptive content</p>
        <p>• Spam or send unsolicited communications</p>
        <p>• Violate intellectual property rights of others</p>
        <p>• Attempt to access other users' data or accounts</p>
        <p>• Reverse-engineer or resell the Service without permission</p>
        <p>• Overload our systems with excessive automated requests</p>
      </Section>

      <Section title="6. Your Content">
        <p>You retain ownership of content you create using the Service. By using the Service,
        you grant us a limited license to process and store your content solely to deliver
        the Service to you. We will not sell or share your content with third parties.</p>
      </Section>

      <Section title="7. AI-Generated Content Disclaimer">
        <p>AI-generated content may contain inaccuracies, errors, or inappropriate material.
        You are responsible for reviewing all AI-generated content before publishing or
        distributing it. We are not liable for any consequences arising from use of
        AI-generated content without review.</p>
      </Section>

      <Section title="8. Payment">
        <p>All payments are processed securely via PayPal. Prices are in USD. The lifetime
        access price is a one-time charge — there are no recurring fees unless you
        explicitly purchase a subscription product.</p>
      </Section>

      <Section title="9. Refunds">
        <p>See our <a href="/refund" className="text-blue-400 hover:underline">Refund Policy</a> for
        full details. In summary: we offer a 30-day satisfaction guarantee on lifetime
        purchases.</p>
      </Section>

      <Section title="10. Limitation of Liability">
        <p>To the maximum extent permitted by law, globalnow.biz shall not be liable for any
        indirect, incidental, special, consequential, or punitive damages, or any loss of
        profits or revenue, whether incurred directly or indirectly. Our total liability
        for any claim arising from the Service is limited to the amount you paid us in
        the 12 months prior to the claim.</p>
      </Section>

      <Section title="11. Termination">
        <p>We may suspend or terminate accounts that violate these Terms. You may cancel
        your account at any time by contacting support@globalnow.biz. Cancellation does
        not entitle you to a refund outside of our 30-day refund window.</p>
      </Section>

      <Section title="12. Changes to Terms">
        <p>We may update these Terms. We will notify registered users of material changes
        by email at least 14 days in advance. Continued use after changes take effect
        constitutes acceptance.</p>
      </Section>

      <Section title="13. Governing Law">
        <p>These Terms are governed by the laws of the State of Florida, United States,
        without regard to conflict of law principles.</p>
      </Section>

      <Section title="14. Contact">
        <p>Questions? Email <a href="mailto:support@globalnow.biz" className="text-blue-400 hover:underline">support@globalnow.biz</a></p>
      </Section>
    </div>
  </div>
);

export default Terms;
